import { IUserNotificationResponseModel } from '@/api/typings-generated/user-notification'
import { IResponseModelWrapper } from '@/api/typings-generated/general'
import { AxiosResponse } from 'axios'
import request from '@/utils/request'

export class UserNotificationsApi {
  TIMEOUT = 0
  API_PATH = process.env.BASE_URL + 'api/notifications'

  async fetchUserNotifications(
    currentPage: number,
    perPage: number,
    userGuid: string | null,
    isRead: boolean | null,
    isArchived: boolean | null,
    entityNames: string[],
    fromDate: Date | null,
    toDate: Date | null
  )
    : Promise<IResponseModelWrapper<IUserNotificationResponseModel>> {
    const params: any = {
      userGuid,
      isRead,
      isArchived,
      entityNames,
      fromDate,
      toDate,
      pageNum: currentPage,
      perPage
    }
    const axiosResponse: AxiosResponse = await request({
      url: `${this.API_PATH}/list`,
      method: 'get',
      params: params
    })

    return new Promise(resolve =>
      setTimeout(() => resolve(axiosResponse.data), this.TIMEOUT)
    )
  }

  async markNotificationsAsRead(
    userNotificationIds: number[],
    isRead: boolean
  )
    : Promise<IResponseModelWrapper<boolean>> {
    const params: any = {
      userNotificationIds,
      isRead
    }
    const axiosResponse: AxiosResponse = await request({
      url: `${this.API_PATH}/markAsRead`,
      method: 'post',
      params: params
    })

    return new Promise(resolve =>
      setTimeout(() => resolve(axiosResponse.data), this.TIMEOUT)
    )
  }

  async archiveNotifications(
    userNotificationIds: number[],
    isArchived: boolean
  )
    : Promise<IResponseModelWrapper<boolean>> {
    const params: any = {
      userNotificationIds,
      isArchived
    }
    const axiosResponse: AxiosResponse = await request({
      url: `${this.API_PATH}/archive`,
      method: 'post',
      params: params
    })

    return new Promise(resolve =>
      setTimeout(() => resolve(axiosResponse.data), this.TIMEOUT)
    )
  }

  async hasNewNotifications(
    since: Date
  )
    : Promise<IResponseModelWrapper<boolean>> {
    const params: any = {
      since
    }
    const axiosResponse: AxiosResponse = await request({
      url: `${this.API_PATH}/hasNewNotifications`,
      method: 'get',
      params: params
    })

    return new Promise(resolve =>
      setTimeout(() => resolve(axiosResponse.data), this.TIMEOUT)
    )
  }

  async getFilterEntities()
    : Promise<IResponseModelWrapper<string[]>> {
    const axiosResponse: AxiosResponse = await request({
      url: `${this.API_PATH}/getFilterEntities`,
      method: 'get'
    })

    return new Promise(resolve =>
      setTimeout(() => resolve(axiosResponse.data), this.TIMEOUT)
    )
  }
}

export const UserNotifications = new UserNotificationsApi()
